const trustedFormConfig = {
  mappedAdmiralQuestionId: '79475aaf-a16f-11ed-b8e1-06faf8b4041b',
  questionText: 'Trusted Form',
  maxRetryAttempts: 7,
  loadRetryAttemptTimingMap: {
    1: 1000,
    2: 2000,
    3: 4000,
    4: 8000,
    5: 16000,
    6: 32000,
    7: 64000,
  },
  // In slow network speed conditions (namely 3G) it takes the TF bootstrap script ~5.5 seconds to create & load the TF assets (certificate and handler script)
  slowNetworkResilientLatency: 15000,
};

export default trustedFormConfig;
